import styled from '@emotion/styled/macro';

export const Wrapper = styled.a`
    width: calc(100% - 32px);
    padding: 0 16px;
    background-color: ${props => props.theme.colours.skybet.blue};
    color: white;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: ${props => props.theme.fonts.medium};
    text-decoration: none;

    @media (max-width: 340px) {
        font-size: 12px;
    }
`;

export const SkyBetLogo = styled.img`
    width: 54px;
    margin-left: 4px;
`;

export const RightCaret = styled.img`
    width: 8px;
    margin-left: auto;
`;
